/**
 * Hope3DAvatarIframe - 3D Avatar Display
 *
 * Displays YOUR Hope character using Convai Pixel Streaming
 * Shows professional healthcare avatar with Convai experience embed
 */

import React from 'react';
import HopeConvaiEmbed from './HopeConvaiEmbed';

interface Hope3DAvatarIframeProps {
  isTalking?: boolean;
  isListening?: boolean;
  visemeData?: number[] | null;
}

export default function Hope3DAvatarIframe({
  isTalking = false,
  isListening = false,
}: Hope3DAvatarIframeProps) {
  return (
    <div style={styles.container}>
      {/* Convai Experience Container with Hope's character — clean, no overlays */}
      <div style={styles.modelContainer}>
        <HopeConvaiEmbed isTalking={isTalking} isListening={isListening} />
      </div>
    </div>
  );
}

// Styles
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
  },
  modelContainer: {
    flex: 1,
    position: 'relative',
    width: '100%',
    minHeight: '300px',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundImage: 'url(/hope-background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pulseIndicator: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'rgba(135, 206, 235, 0.95)',
    padding: '8px 16px',
    borderRadius: '20px',
    pointerEvents: 'none',
    zIndex: 10,
  },
  pulseDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    animation: 'pulse 1.5s ease-in-out infinite',
  },
  pulseText: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#ffffff',
  },
  soundWaves: {
    position: 'absolute',
    bottom: '20px',
    left: '20px',
    display: 'flex',
    gap: '6px',
    pointerEvents: 'none',
    zIndex: 10,
  },
  wave1: {
    width: '4px',
    height: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '2px',
    animation: 'wave 0.6s ease-in-out infinite',
    animationDelay: '0s',
  },
  wave2: {
    width: '4px',
    height: '24px',
    backgroundColor: '#ffffff',
    borderRadius: '2px',
    animation: 'wave 0.6s ease-in-out infinite',
    animationDelay: '0.2s',
  },
  wave3: {
    width: '4px',
    height: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '2px',
    animation: 'wave 0.6s ease-in-out infinite',
    animationDelay: '0.4s',
  },
  status: {
    padding: '12px',
    textAlign: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderTop: '1px solid #e0e0e0',
  },
  statusText: {
    fontSize: '13px',
    color: '#0F4C75',
    fontWeight: '600',
  },
};
